import { observer } from 'mobx-react-lite';
import { NotepadUI } from '../features/notepad/ui/notepad-ui';

export const NotepadObserver = observer(() => {
  return <NotepadUI />;
});
